var sliderThumbs;
var sliderImages;
var gallerySlider;


$(document).ready(function() {
    if ($('.product').length) {

        sliderThumbs = new Swiper(".thumbnail-slider", {
            slidesPerView: 7,
            spaceBetween: 10,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    slidesPerView: 4.7,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 6.7,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 9.7,
                    spaceBetween: 10,
                },
                1200: {
                    slidesPerView: 6.7,
                    spaceBetween: 10,
                }
            },
        });

        sliderImages = new Swiper(".main-slider", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            mousewheel: false,
            navigation: {
                nextEl: ".main-slider-next",
                prevEl: ".main-slider-prev"
            },
            grabCursor: true,
            thumbs: {
                swiper: sliderThumbs
            }
        });

        gallerySlider = new Swiper(".gallery-slider", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            grabCursor: true,
            watchSlidesProgress: true,
        });

        gallerySlider.controller.control = sliderImages;
        sliderImages.controller.control = gallerySlider;
    }
  
    if ($('.prod-banner--slider').length){
        new Swiper('.prod-banner--slider', {
            effect: 'creative',
            creativeEffect: {
              prev: {
                shadow: true,
                translate: [0, 0, -1],
              },
              next: {
                translate: ['100%', 0, 0],
              },
            },
            slidesPerView: 1,
            loop: false,
            speed: 800,
            autoplay: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
      });
    }

  
    if ($('.custom-steps-slider-section').length) {
          $('.custom-steps-slider .owl-carousel').each(function() {
              let $carousel = $(this);
              let $floatNav = $('.custom-steps-slider .float-nav');
  
              let owl = $carousel.owlCarousel({
                  items: 3,
                  nav: true,
                  dots: false,
                  smartSpeed: 800,
                  loop: false,
                  autoplay: false,
                  autoplayTimeout: 5000,
                  margin: 20,
                  responsive: {
                      0: {
                          items: 1,
                          stagePadding: 20
                      },
                      1280: {
                          items: 3
                      }
                  }
              }).on('changed.owl.carousel', function(event) {
                  let currentIndex = event.item.index;
                  let totalItems = event.item.count;
                  let pageSize = event.page.size;
  
                  if (currentIndex === 0) {
                  } else {
                      $floatNav.find('.owl-prev').prop('disabled', false);
                  }
  
                  if (currentIndex >= totalItems - pageSize) {
                  } else {
                      $floatNav.find('.owl-next').prop('disabled', false);
                  }
              });
  
              $floatNav.find('.owl-prev').on('click', function() {
                  owl.trigger('prev.owl.carousel');
              });
              $floatNav.find('.owl-next').on('click', function() {
                  owl.trigger('next.owl.carousel');
              });
  
              $(this).trigger('refresh.owl.carousel');
          }); 

          $('.custom-steps-slider-section .play-button-icon').click(function(){
              $('.custom-steps-slider-modal').addClass('active');
          })
    }

  
    if ($('.product-page-nav-header-section').length) {
        const buyNowButton = document.querySelector('.btn-product-buy-now');
        if (buyNowButton) {
            const syncBuyNowLabel = () => {
                $('.product-page-nav-header-section .nav-header-buy-now').text(buyNowButton.textContent.trim());
            };
            syncBuyNowLabel();
            new MutationObserver(syncBuyNowLabel).observe(buyNowButton, {
                childList: true,
                characterData: true,
                subtree: true
            });
        }

        $('.custom-select-nav').click(function(){
            $(this).toggleClass('active');
        });
        $('.product-page-nav-header-section .btn.buy-now').click(function() {
            let $this = $(this);
            if ($this.data('clicked')) return; // Prevent multiple clicks
    
            $this.data('clicked', true); // Mark as clicked
            $('#more-payment-options-link').click();
    
            setTimeout(() => {
                $this.removeData('clicked'); // Allow clicking again after delay
            }, 1000); // Adjust delay as needed
        });
  
      
        $('.product-page-nav-header-section').each(function () {
            var $container = $(this); 
            $container.find('.nav-content .link-nav span').click(function(){
              
              
                $('.nav-content .link-nav span').removeClass('active');
                $(this).addClass('active');
                $('.selected-nav').text($(this).text());
        
              
                var targetAttr = $(this).attr('data-scroll');
                var $targetSection = $('.section-scroll[data-scroll="' + targetAttr + '"]').offset().top - 50;
                $("html, body").animate({
                    scrollTop: $targetSection
                }, 1);
            });
        });
      
        $('.main-nav-header-section .nav-header-buy-now').click(function() {
            $('.btn-product-buy-now').click();
        });      
        
        if ($('.amazon-link').length) {
          const amazonHref = $('.amazon-link').attr('href');
            if ($('.buy-amazon').length){
                
            }else{
        
                $('.nav-column.btn-nav .btn-container').append(`
                    <a href="${amazonHref}" target="_blank" class="btn buy-amazon body pp-medium d-flex align-items-center justify-content-center gap-2">
                    <span class="d-lg-block d-md-block d-sm-none">Buy On Amazon</span>
                    <span class="d-lg-none d-md-none d-sm-block">Buy On</span>
                    <img src="https://cdn.shopify.com/s/files/1/0474/8365/0202/files/amazon.png?v=1749743497" class="amazon-icon d-lg-none d-md-none d-sm-block">
                    </a> 
                `);
            }
        }
      
      
    }
    
    if ($('.video-mask-scroll-section').length) {
        $('.video-mask-scroll-section .btn-watch').click(function(){
           $('.video-mask-scroll-section .mask-video-modal').addClass('active')
        });
    }
    
    if ($('.image-slide-scale-section').length) {
        $('.image-slide-scale-section').each(function() {
            const $section = $(this); // Scope to current section

            function setImageScaleHeight() {
                const firstImg = $section.find('.image-scale-item:first img');

                firstImg.on('load', function () {
                    const firstImageHeight = this.getBoundingClientRect().height;
                    if (firstImageHeight > 0) {
                        $section.find('.image-scale-item').css('height', (firstImageHeight - 25) + 'px');
                    }
                }).each(function () {
                    if (this.complete) $(this).trigger('load');
                });
            }

            setImageScaleHeight();
            $(window).on('resize', setImageScaleHeight);

            const $imageItems = $section.find('.image-scale-item');
            const $descItems = $section.find('.description-item-desktop');
            let currentIndex = $imageItems.index($section.find('.image-scale-item.active'));

            function updateSlide(newIndex) {
                $imageItems.removeClass('active').eq(newIndex).addClass('active');
                $descItems.removeClass('active').eq(newIndex).addClass('active');
                currentIndex = newIndex;
            }

            $section.find('.image-slide-scale-button-next').on('click', function() {
                const newIndex = (currentIndex + 1) % $imageItems.length;
                updateSlide(newIndex);
            });

            $section.find('.image-slide-scale-button-prev').on('click', function() {
                const newIndex = (currentIndex - 1 + $imageItems.length) % $imageItems.length;
                updateSlide(newIndex);
            });

            $imageItems.on('click', function() {
                const clickedIndex = $imageItems.index(this);
                updateSlide(clickedIndex);
            });

            // Init Swiper for this section only
            const swiper = new Swiper($section.find('.image-slider-scale-container')[0], {
                slidesPerView: 1,
                spaceBetween: 70,
                allowTouchMove: true,
                loop: true,
                navigation: {
                    nextEl: $section.find('.image-slide-scale-button-next')[0],
                    prevEl: $section.find('.image-slide-scale-button-prev')[0],
                },
                on: {
                    init: function() {
                        generateImagePagination(this, $section);
                        updateActiveThumb(this.realIndex, $section);
                        updateActiveDescription(this.realIndex, $section);
                    },
                    slideChange: function() {
                        updateActiveThumb(this.realIndex, $section);
                        updateActiveDescription(this.realIndex, $section);
                    }
                }
            });

            function generateImagePagination(swiper, $scope) {
                const $pagination = $scope.find('.image-pagination');
                swiper.slides.forEach((slide, index) => {
                    if (slide.classList.contains('swiper-slide-duplicate')) return;
                    const imgSrc = slide.querySelector('img').src;
                    const thumb = document.createElement('div');
                    thumb.classList.add('thumb');
                    thumb.innerHTML = `<img src="${imgSrc}" alt="thumb" />`;
                    thumb.addEventListener('click', () => swiper.slideToLoop(index));
                    $pagination.append(thumb);
                });
            }

            function updateActiveThumb(activeIndex, $scope) {
                $scope.find('.image-pagination .thumb').each(function(idx) {
                    $(this).toggleClass('active', idx === activeIndex);
                });
            }

            function updateActiveDescription(index, $scope) {
                $scope.find('.description-scale-container-mobile .description-item').each(function(i) {
                    $(this).toggleClass('active', i === index);
                });
            }
        });
    }
  
    if ($('.expert-review-section').length) {
        $('.expert-review-section').each(function () {
          var expert_review_slider = new Swiper('.expert-review-section .expert-review-slider', {
              slidesPerView: 3,
              spaceBetween: 70,
              allowTouchMove: true,
              loop: true,
              autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true,
              },
              navigation: {
                  nextEl: '.expert-review-button-next',
                  prevEl: '.expert-review-button-prev',
              },
              breakpoints: {
                  // For screens greater than or equal to 1024px (Desktop)
                  1024: {
                      slidesPerView: 3,   // 3 slides for desktop
                  },
                  // For screens between 768px and 1023px (Tablet)
                  768: {
                      slidesPerView: 1,   // 1 slide for tablets
                  },
                  // For screens less than 768px (Mobile)
                  0: {
                      slidesPerView: 1,   // 1 slide for mobile
                  },
              }
          });
      });
    }

    if ($('.video-image-content-slider-section').length) {
        var $sliderWrapper = $('#shopify-section-' + product_video_image_sectionId + ' .video-image-content-slider-container');
        var slides = $sliderWrapper.find('.custom-slide');
        var slideCount = slides.length;
        var currentIndex = 0;
    
        function getCurrentSlideWidth(index) {
            return $(slides[index]).outerWidth(true);
        }
    
        function goToSlide(index) {
            let totalWidth = 0;
            for (let i = 0; i < index; i++) {
                totalWidth += getCurrentSlideWidth(i);
            }
            $sliderWrapper.find('.custom-slider').css('transform', 'translateX(' + (-totalWidth) + 'px)');
    
            slides.removeClass('active');
            $(slides[index]).addClass('active');
    
            slides.each(function(i) {
                const video = $(this).find('video').get(0);
                if (video) {
                    if (i === index) {
                        video.play();
                    } else {
                        video.pause();
                    }
                }
            });
        }
    
        slides.eq(0).addClass('active');
    
        $('#shopify-section-' + product_video_image_sectionId + ' .video-image-content-button-next').on('click', function() {
            if (currentIndex < slideCount - 1) {
                currentIndex++;
                goToSlide(currentIndex);
            }
        });
    
        $('#shopify-section-' + product_video_image_sectionId + ' .video-image-content-button-prev').on('click', function() {
            if (currentIndex > 0) {
                currentIndex--;
                goToSlide(currentIndex);
            }
        });
    
        function videocontentupdateWidths() {
            if ($('#shopify-section-' + product_video_image_sectionId + ' .custom-slider').length > 0) {
                $('#shopify-section-' + product_video_image_sectionId + ' .custom-slide').each(function() {
                    var $containerSlide = $(this);
                    var $videoContainer = $containerSlide.find('video');
                    var $imageContainer = $containerSlide.find('img');
    
                    if ($videoContainer.length > 0) {
                        $videoContainer.on('loadeddata', function() {
                            const videoEl = this;
                            setTimeout(() => {
                                const renderedWidth = videoEl.getBoundingClientRect().width;
                                $containerSlide.find('.description').css('width', renderedWidth + 'px');
                            }, 100);
                        });
                    }
    
                    if ($imageContainer.length > 0) {
                        var containerWidth = $imageContainer.width();
                        $containerSlide.find('.description').css('width', containerWidth);
                    }
                });
            }
        }
    
        videocontentupdateWidths();
    
        $(window).resize(function() {
            clearTimeout(this.resizeTO);
            this.resizeTO = setTimeout(function() {
                videocontentupdateWidths();
            }, 200);
        }); 
    }

    if ($('.product-image-slider-section').length) {
      
        var new_image_content_slider = new Swiper('.product-image-slider', {
            slidesPerView: 2,
            spaceBetween: 20,
            allowTouchMove: false,
            loop: true,
            autoplay: {
              delay: 3000,
              pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: '.new-image-content-button-next',
                prevEl: '.new-image-content-button-prev',
            },
            breakpoints: {
                // For screens greater than or equal to 1024px (Desktop)
                1024: {
                    slidesPerView: 2,   // 2 slides for desktop
                },
                // For screens between 768px and 1023px (Tablet)
                768: {
                    slidesPerView: 1,   // 1 slide for tablets
                },
                // For screens less than 768px (Mobile)
                0: {
                    slidesPerView: 1,   // 1 slide for mobile
                },
            }
        });

    }
  
    if ($('.bundle-add-on-section').length) {
        $('.variant-item-container').on('click', function() {
          $('.variant-item-container').removeClass('active');
          $(this).addClass('active');
          var variantID = $(this).attr('variant-id');
          var featuredImage = $(this).attr('variant-featured-image');
          var variantLabel = $(this).find('.variant-label').text();
          var variantDescription = $(this).attr('variant-description');
          var variantSalePrice = $(this).attr('variant-sale-price');
          var variantComparePrice = $(this).attr('variant-compare-price');
          
          $('.produt-variant-information img').attr('src', featuredImage);
          $('.produt-variant-information .variant-label').text(variantLabel);
          $('.produt-variant-information .variant-description').text(variantDescription);
          $('.produt-variant-information .sale-price').text(variantSalePrice);
          $('.produt-variant-information .compare-price').text(variantComparePrice);
          $('.produt-variant-information .btn-buy-now').attr('data-variant-id', variantID);
        });
    }

    if ($('.technical-specification-section').length) {
        $('.technical-specification-section .first-specs .accordion-button').click();
    }
  
    if ($('.centered-images-slider-section').length) {
        new Swiper('.centered-images-slider-container', {
            slidesPerView: 1.5,
            spaceBetween: 20,
            loop: true,
            centeredSlides: true,
            allowTouchMove: true,
            navigation: {
                nextEl: '.centered-images-button-next',
                prevEl: '.centered-images-button-prev',
            },
              breakpoints: {
                  // For screens greater than or equal to 1024px (Desktop)
                  1024: {
                      slidesPerView: 1.5,   // 3 slides for desktop
                  },
                  // For screens between 768px and 1023px (Tablet)
                  768: {
                      slidesPerView: 1.2,   // 1 slide for tablets
                  },
                  // For screens less than 768px (Mobile)
                  0: {
                      slidesPerView: 1.2,   // 1 slide for mobile
                  },
              }
        });
    }
  
    if ($('.new-image-slider-section').length) {
        new Swiper('.mid-image-slider', {
            slidesPerView: 1,
            loop: false,
            speed:800,
            spaceBetween: 0,
            allowTouchMove: true,
            navigation: {
                nextEl: '.image-content-button-next',
                prevEl: '.image-content-button-prev',
            },
            pagination: {
                el: '.bottom-pagination-slider',
                clickable: true,
                renderBullet: function (index, className) {
                    return `<span class="tab-pagination body-lg pp-medium text-capitalize ${className}" data-index="${index}" title="${slideTitles_image_sliderV2[index]}">${slideTitles_image_sliderV2[index]}</span>`;
                },
            },
        });
    }
  
    if ($('.faqs-section').length) {
        $('.faqs-container').accordion({
            heightStyle: "content",
            active: false,
            collapsible: true
        });
        $('.faqs-container').accordion('option', 'active', 0);
    
        $('.faqs-list-container').each(function(){
            var $container = $(this); 
    
            $container.find('.link-tab').click(function(){
                $('.faqs-list-container .link-tab').removeClass('active');
                $(this).addClass('active');
                
                $('.tab-container-list').removeClass('active');
    
                $('.tab-container-list[data-tab-index="'+ $(this).attr('data-tab-index') +'"]').addClass('active');
                
            });
        });
    }

    if ($('.related-products-section').length) {
        const productRecommendationsSection = document.querySelector('.product-recommendations');
        if (productRecommendationsSection) {
            const url = productRecommendationsSection.dataset.url;

            fetch(url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');

                if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;
                }

                $('.related-products-slider .owl-carousel').each(function () {
                    let $carousel = $(this);
                    let $floatNav = $('.related-products-slider .float-nav');

                    let owl = $carousel.owlCarousel({
                    items: 4,
                    nav: true,
                    dots: false,
                    smartSpeed: 800,
                    loop: false,
                    autoplay: false,
                    autoplayTimeout: 5000,
                    margin: 20,
                    responsive: {
                        0: {
                        items: 1,
                        stagePadding: 20
                        },
                        1000: {
                        items: 3
                        },
                        1280: {
                        items: 4
                        }
                    }
                    }).on('changed.owl.carousel', function (event) {
                    let currentIndex = event.item.index;
                    let totalItems = event.item.count;
                    let pageSize = event.page.size;

                    if (currentIndex === 0) {
                        // Optional: Disable prev if needed
                    } else {
                        $floatNav.find('.owl-prev').prop('disabled', false);
                    }

                    if (currentIndex >= totalItems - pageSize) {
                        // Optional: Disable next if needed
                    } else {
                        $floatNav.find('.owl-next').prop('disabled', false);
                    }
                    });

                    $floatNav.find('.owl-prev').on('click', function () {
                    owl.trigger('prev.owl.carousel');
                    });
                    $floatNav.find('.owl-next').on('click', function () {
                    owl.trigger('next.owl.carousel');
                    });

                    $carousel.trigger('refresh.owl.carousel');
                });
                
            })
            .catch(e => {
                console.error(e);
            });
        }
    }


    nav_header_scroll();
    mask_video_scroll_section();
    mask_video_scroll_2_section();
    tv_animation_section();
    
    $('.discount-banner-content').each(function() {
        $(this).find('.copy-code-btn').click(function() {
            var discountCode = $(this).closest('.discount-banner-content').find('.discount-code-input').text(); // or .val() if it's an input
            navigator.clipboard.writeText(discountCode).then(function() {
                // Show toast notification
                var x = $('#toastCustom');
                x.text('The discount code has been copied to the pasteboard!');
                x.addClass('show');
                setTimeout(function() {
                    x.removeClass('show');
                }, 3000); // Hide after 3 seconds
            }, function(err) {
                console.error('Failed to copy discount code:', err);
            });
        });
    });

  
    if ($('.partner-review-section').length) {
        var review_slider = new Swiper('.partner-review-section .content-slider-section', {
            centeredSlides: true,
            direction: "vertical",
            effect: "slide",
            loopedSlides: 5,
            speed: 1000,
            observer: true,
            loop:true,
            observeParents: true,
        });
        
        var review_icon_slider = new Swiper('.partner-review-section .partner-logo-container', {
            autoplay: {
                disableOnInteraction: false
            },
            autoplay: false,
            slidesPerView: 5,
            slideToClickedSlide: true,
            loopedSlides: 5,
            loop:true,
            centeredSlides: true,
            speed: 1000,
            observer: true,
            observeParents: true,
            freeMode: false,
            breakpoints: {
                320: {
                    slidesPerView: 1.8,
                    spaceBetween: 15,
                },
                499: {
                    slidesPerView: 1.8,
                    spaceBetween: 15,
                },
                991: {
                    slidesPerView: 5,
                    spaceBetween: 30,
                }
            }
        });
    
        review_slider.controller.control = review_icon_slider;
        review_icon_slider.controller.control = review_slider;
    }
  
    if ($('.featured-video-container-section').length || $('.image-with-slider-section').length) {
        updateWidths();
        $('.learn-more-btn').click(function() {
            var $section = $('.featured-video-slider-section[data-id-section="' + $(this).attr('data-id-section') + '"]');
            
            // Check if the section is currently active
            if ($section.hasClass('active')) {
              
            } else {
        
                $(this).addClass('active');
        
                // Get the full height of the section
                var fullHeight = $section.find('.inner-section').height();
                
                // Add the active class and set the height to 0
                $section.addClass('active').css('height', 0);
                
                // Animate height from 0 to full height
                $section.animate({ height: fullHeight }, 500, function() {
                    // After expanding, scroll to the section
                });
              
                $section.find('.aos-init').addClass('aos-animate');
                $('html, body').animate({
                    scrollTop: $section.offset().top - 100
                }, 200);
            }
        });
        $('.featued-video-button-close').click(function(){
            var $section = $('.featured-video-slider-section[data-id-section="' + $(this).attr('data-id-section') + '"]');
            if ($section.hasClass('active')) {
                $section.find('.aos-init').removeClass('aos-animate');
                
                $('.learn-more-btn[data-id-section="'+ $(this).attr('data-id-section') +'"]').removeClass('active');
                // Animate height from current height to 0
                $section.animate({ height: 0 }, 500, function() {
                    // Remove the active class after the animation completes
                    $section.removeClass('active');
                });
            }
        })
      
        function updateWidths() {
            if ($('.featured-slide').length > 0) {
                $('.featured-slide').each(function () {
                var $slide = $(this);

                // Desktop containers
                var $videoDesktop = $slide.find('.featured-video-container video.d-lg-block, .featured-video-container video.d-md-block');
                var $imageDesktop = $slide.find('.featured-image-container img.pc-side');
                var $headingDesktop = $slide.find('.heading.pc-side');

                // Mobile containers
                var $videoMobile = $slide.find('.featured-video-container video.d-sm-block');
                var $imageMobile = $slide.find('.featured-image-container img.mobile-side');
                var $headingMobile = $slide.find('.heading.mobile-side');

                // Desktop width
                if ($videoDesktop.length > 0) {
                    $headingDesktop.css('width', $videoDesktop.width());
                } else if ($imageDesktop.length > 0) {
                    $headingDesktop.css('width', $imageDesktop.width());
                }

                // Mobile width
                if ($videoMobile.length > 0) {
                    $headingMobile.css('width', $videoMobile.width());
                } else if ($imageMobile.length > 0) {
                    $headingMobile.css('width', $imageMobile.width());
                }
                });
            }
        }
        
        $(window).resize(function() {
            clearTimeout(this.resizeTO);
            this.resizeTO = setTimeout(function() {
                if ($('.featured-video-container-section').length || $('.image-with-slider-section').length) {
                    updateWidths(); 
                }
            }, 200);
        });
    }
  
    if ($('.content-image-slider-section').length) {
       
        var top_header_slider = new Swiper('.top-header-slider', {
            slidesPerView: 1,
            loop:false,
            autoHeight: true,
            speed:800,
            fadeEffect: { crossFade: true },
            effect: "fade",
            allowTouchMove: false,
        });
      
          var mid_image_slider = new Swiper('.mid-image-slider', {
              slidesPerView: 1,
              loop: false,
              speed:800,
              allowTouchMove: true,
              pagination: {
                  el: '.bottom-pagination-slider',
                  clickable: true,
                  renderBullet: function (index, className) {
                      return `<span class="tab-pagination text-capitalize body-lg pp-medium ${className}" data-index="${index}" title="${slideTitles[index]}">${slideTitles[index]}</span>`;
                  },
              },
          });
      
          
          mid_image_slider.controller.control = top_header_slider;
    }

  
    if ($('.compatible-accessories-lists').length) {
        $('.compatible-accessories-lists .compatible-accessories-item').each(function() {
            const $item = $(this);
            const $checkbox = $item.find('.additional_checkbox');
            const accessoryProductId = String($item.data('accessory-product-id'));
            const targetFormId = $item.data('target-form-id');
            const targetFormElement = targetFormId ? document.getElementById(targetFormId) : null;
            const $targetForm = targetFormElement
                ? $(targetFormElement)
                : $item.closest('.product').find('.product-form .atc-form').first();

            function getAccessoryInput() {
                return $targetForm.find(`input[data-accessory-product-id="${accessoryProductId}"]`);
            }

            function syncAccessoryInput() {
                const variantId = $item.find('.compatible-variant-input:checked').val() || $checkbox.val();
                let $accessoryInput = getAccessoryInput();

                $checkbox.val(variantId);

                if (!$checkbox.is(':checked')) {
                    $accessoryInput.remove();
                    return;
                }

                if ($accessoryInput.length) {
                    $accessoryInput.val(variantId);
                    return;
                }

                $('<input>', {
                    type: 'hidden',
                    name: 'id[]',
                    value: variantId,
                    'data-accessory-product-id': accessoryProductId
                }).appendTo($targetForm);
            }

            function updateVariantDisplay($variant) {
                const salePrice = $variant.attr('data-sale-price');
                const comparePrice = $variant.attr('data-compare-price');
                const discount = Number($variant.attr('data-discount')) || 0;
                const variantImage = $variant.attr('data-image');
                const hasDiscount = discount > 0 && Boolean(comparePrice);

                $item.find('.sale-price').html(salePrice);
                $item.find('.compare-price')
                    .html(comparePrice)
                    .toggleClass('is-hidden', !hasDiscount);
                $item.find('.badge-sale')
                    .text(hasDiscount ? `${discount}% off` : '')
                    .toggleClass('is-hidden', !hasDiscount);

                if (variantImage) {
                    $item.find('.compatible-accessories-img').attr('src', variantImage);
                }

                syncAccessoryInput();
            }

            $checkbox.on('change', syncAccessoryInput);

            $item.find('.compatible-variant-input').on('change', function() {
                updateVariantDisplay($(this));
            });
        });
    }
        

});


$(window).scroll(function() {
    nav_header_scroll();
    mask_video_scroll_section();
    mask_video_scroll_2_section();
    tv_animation_section();
});


$('.product .main-slider .swiper-slide').on('click', function() {
    $('.mdl[data-mdl="media-gallery"]').fadeIn();

    $('body').css('overflow-y', 'hidden');
});

$('.product .size-fit-btn').on('click', function() {
    $('.mdl[data-mdl="size-fit"]').fadeIn();

    let width = $('.mdl[data-mdl="size-fit"] .mdl-wrapper').outerWidth();
    $('.mdl[data-mdl="size-fit"] .mdl-wrapper').css('left', `calc(100% - ${width}px)`);


    $('body').css('overflow-y', 'hidden');
});



$(document).on('click', '.variant-option-block .variant-colors li', function() {
    $(this).addClass('on').siblings().removeClass('on');
    let colorId = $(this).data('color');

    $(`.product-image img[data-variant="${colorId}"]`).addClass('active').siblings().removeClass('active');
});



$(document).on('click', '.product-card .product-image', function() {
    let link = $(this).data('link');
    if (link) {
        window.location.href = link;
    }
});


  
  if ($('.unboxing-review-section').length) {
        var review_video_slider = new Swiper('.review-video-slider', {
            slidesPerView: 3,
            spaceBetween: 15,
            allowTouchMove: true,
            navigation: {
                nextEl: '.review-video-button-next',
                prevEl: '.review-video-button-prev',
            },
            pagination: {
                el: '.box-pagination',
            },
            breakpoints: {
                // For screens greater than or equal to 1024px (Desktop)
                1024: {
                    slidesPerView: 3, // 3 slides for desktop
                },
                // For screens between 768px and 1023px (Tablet)
                768: {
                    slidesPerView: 2.1, // 1 slide for tablets
                    centeredSlides: true,
                },
                // For screens less than 768px (Mobile)
                0: {
                    slidesPerView: 1.1, // 1 slide for mobile
                    centeredSlides: true,
                },
            }
        });
        
        
        function openVideo(element, video_id) {
            var videoModalBody = $("#modal #embed_video");
            var iframe = document.createElement('iframe');
            iframe.src = video_id + '?autoplay=1'; // Add autoplay parameter
            iframe.className = 'embed-responsive-item';
            iframe.setAttribute('allowfullscreen', '');
        
            // Empty the modal body and append the new iframe
            videoModalBody.empty();
            videoModalBody.append(iframe);
        
            // Show the modal
            $("#modal ").addClass('active');
        
            // Use YouTube API to play the video after the modal is shown
            $("#modal").on('embed_video', function() {
                var player = new YT.Player(iframe, {
                    events: {
                        'onReady': function(event) {
                            event.target.playVideo();
                        }
                    }
                });
            });
        }
        
        
        async function fetchYouTubeData(videoId, element) {
            const oEmbedUrl = `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`;
        
            try {
                const response = await fetch(oEmbedUrl);
                if (!response.ok) {
                    if (response.status === 404) {
                        console.error('Video not found (404).');
                    } else if (response.status === 403) {
                        console.error('Access forbidden (403).');
                    } else {
                        console.error();
                    }
                    return;
                }
        
                const videoData = await response.json();
                if (videoData) {
        
                    element.querySelector('.rev-yt-details h4').innerText = videoData.title;
                    element.querySelector('.rev-yt-profile p').innerText = videoData.author_name;
                    element.querySelector('.rev-yt-profile img').src = videoData.thumbnail_url;
        
                } else {
                    console.error('No video data found for ID:', videoId);
                }
            } catch (error) {
                console.error('Error fetching YouTube data:', error);
            }
        }
        
        document.addEventListener("DOMContentLoaded", function() {
            document.querySelectorAll('.review-video-item').forEach(function(element) {
                const videoId = element.getAttribute('data-video-id');
                fetchYouTubeData(videoId, element);
            });
        });
    
  }

// FUNCTIONS ----------------------------------------------------------------------------------------------

function nav_header_scroll(){
  if ($('.product-page-nav-header-section').length) {
      $('.product-page-nav-header-section').each(function () {

        // Get the top offset of the .product-header-section
        var productHeaderTop = $('.product-page-nav-header-section').offset().top + 150;
        var scrollPosition = $(window).scrollTop();

        // Check the scroll position
        if ($(window).scrollTop() >= productHeaderTop) {
            // Make the .product-header-section sticky
            $('.main-nav-header-section').addClass('product-header-sticky');
            // Hide the header
            $('nav.header').addClass('header-hide');
        } else {
            // Remove the sticky class when scrolling above the section
            $('.main-nav-header-section').removeClass('product-header-sticky');
            // Show the header again
            $('nav.header').removeClass('header-hide');
        }
        

      });

      $(".section-scroll").each(function() {
          var sectionTop = $(this).offset().top - 100;
          var sectionBottom = sectionTop + $(this).outerHeight();
          var scrollPosition = $(window).scrollTop();
          
          var targetButton = $('.product-page-nav-header-section .nav-content .link-nav span[data-scroll="' + $(this).attr('data-scroll') + '"]');
      
          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              targetButton.addClass("active");
              
              // Check if the section has a data-child-scroll attribute
              var childScroll = $(this).attr("data-child-scroll");
              if (childScroll) {
                  $('.product-page-nav-header-section .nav-content .link-nav span[data-scroll="' + childScroll + '"]').addClass("active");
              }
          } else {
              if (!$(this).attr("data-child-scroll")) {
                  targetButton.removeClass("active");
              }
          }
      });
  }
}


function mask_video_scroll_section(){
  if ($('.video-mask-scroll-section').length) {
      $('.video-mask-scroll-section').each(function() {
        let el = $(this);
        let video = el.find('.bg-video').get(0);

        if (visiblePercent(el) > 15) {
            video.play();
            $('.video-mask-scroll-section .box-container').addClass('animate');
        }else{
            $('.video-mask-scroll-section .box-container').removeClass('animate');
        }
        if (visiblePercent(el) > 30) {
            $(this).find('.phase-1').addClass('animate');
        }else{
            $(this).find('.phase-1').removeClass('animate');
        }
        if (visiblePercent(el) > 50) {
            $(this).find('.phase-2').addClass('animate');
            $(this).find('.phase-1').addClass('animate-text');
        }else{
            $(this).find('.phase-2').removeClass('animate');
            $(this).find('.phase-1').removeClass('animate-text');
        }
        if (visiblePercent(el) > 70){
            $(this).find('.phase-2').addClass('animate-text');
        }else{
            $(this).find('.phase-2').removeClass('animate-text');
        }
        if (visiblePercent(el) > 80){
            $(this).find('.bottom-details').addClass('animate');
        }else{
            $(this).find('.bottom-details').removeClass('animate');
        }


        
      });     
  
  }
}

function mask_video_scroll_2_section(){
  if ($('.video-mask-scroll-section-2').length) {
      $('.video-mask-scroll-section-2').each(function() {
        let el = $(this);
        let video = el.find('.bg-video').get(0);

        if (visiblePercent(el) > 15) {
            video.play();
            $('.video-mask-scroll-section-2 .box-container').addClass('animate');
        }else{
            $('.video-mask-scroll-section-2 .box-container').removeClass('animate');
        }
        if (visiblePercent(el) > 25) {
            $(this).find('.phase-1').addClass('animate');
        }else{
            $(this).find('.phase-1').removeClass('animate');
        }
        if (visiblePercent(el) > 50) {
            $(this).find('.phase-1').addClass('animate-hide');
            $('.video-mask-scroll-section-2 .box-container').addClass('animate-2');
        }else{
            $('.video-mask-scroll-section-2 .box-container').removeClass('animate-2');
            $(this).find('.phase-1').removeClass('animate-hide');
        }
        if (visiblePercent(el) > 70) {
            $(this).find('.phase-2').addClass('animate');
        }else{
            $(this).find('.phase-2').removeClass('animate');
        }
        if (visiblePercent(el) > 85){
            $(this).find('.phase-2').addClass('animate-text');
        }else{
            $(this).find('.phase-2').removeClass('animate-text');
        }
        

      });     
    
     $('.mobile-mask-container').each(function () {
        let el = $(this);
        if (visiblePercent(el) > 50) {
          $(this).addClass('animate');
        }
    });     
    
    $('.main-mobile-container').each(function () {
            let $container = $(this);
            let percentVisible = visiblePercent($container);
    
            // === Image Rotate (50% to 90%) ===
            let $img = $container.find('.product-image-container img');
            if (percentVisible >= 50 && percentVisible <= 90) {
                let progress = (percentVisible - 50) / 60;
                let rotateDeg = -22 * progress;
                $img.css('transform', `rotate(${rotateDeg}deg)`);
            } else if (percentVisible < 50) {
                $img.css('transform', 'rotate(0deg)');
            } else {
                $img.css('transform', 'rotate(-22deg)');
            }
    
            // === text-1 Animation (55% to 65%) ===
            let $text1 = $container.find('.text-1');
            if (percentVisible >= 55 && percentVisible <= 65) {
                let progress = (percentVisible - 55) / 10;
                let translateY = -65 * progress;
                let opacity = 1 - progress;
                $text1.css({
                    transform: `translateY(${translateY}px)`,
                    opacity: opacity
                });
            } else if (percentVisible < 55) {
                $text1.css({ transform: `translateY(0px)`, opacity: 1 });
            } else {
                $text1.css({ transform: `translateY(-50px)`, opacity: 0 });
            }

       
            // === text-2 Animation (65% to 85%) ===
            let $text2 = $container.find('.text-2');
            if (percentVisible >= 65 && percentVisible <= 85) {
                let progress = (percentVisible - 65) / 35;
                let translateY = 150 * (1 - progress); // from 150px to 0px
                let opacity = progress;
                $text2.css({
                    transform: `translateY(${translateY}px)`,
                    opacity: opacity
                });
            } else if (percentVisible < 65) {
                $text2.css({ transform: `translateY(150px)`, opacity: 0 });
            } else {
                $text2.css({ transform: `translateY(0px)`, opacity: 1 });
            }
       
      });
    
  }
}


function tv_animation_section(){
  if ($('.tv-animation-section').length) {
        $('.tv-animation-section').each(function () {
        let el = $(this);
        let visibility = visiblePercent(el);

        if (visibility > 40) {
            el.addClass('animate');

            el.find('.bg-video').each(function () {
            this.muted = true;
            let playPromise = this.play();
            if (playPromise !== undefined) {
                playPromise.catch(function (error) {
                console.warn('Video play failed:', error);
                });
            }
            });
        }

        if (visibility > 60) {
            el.find('.box-video-container').addClass('animate');
        } else {
            el.find('.box-video-container').removeClass('animate');
        }

        if (visibility > 70) {
            el.find('.box-video-container').addClass('text-animate');
        } else {
            el.find('.box-video-container').removeClass('text-animate');
        }
        });
  }
}
